import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom'; 
import api from '../api/axios';
import { 
    Users, 
    Calendar, 
    Clock, 
    Plus, 
    Check, 
    X, 
    AlertCircle, 
    ArrowRight, 
    Save, 
    Phone, 
    User as UserIcon,
    Shield
} from 'lucide-react';
import './SalonAdmin.css';

const DAYS_OF_WEEK = [
    { id: 0, name: 'شنبه' },
    { id: 1, name: 'یک‌شنبه' },
    { id: 2, name: 'دوشنبه' },
    { id: 3, name: 'سه‌شنبه' },
    { id: 4, name: 'چهارشنبه' },
    { id: 5, name: 'پنج‌شنبه' },
    { id: 6, name: 'جمعه' },
];

export default function SalonAdmin() {
    
    const navigate = useNavigate();
    const { slug } = useParams();

    const [salon, setSalon] = useState(null);
    const [staffList, setStaffList] = useState([]);
    const [services, setServices] = useState([]);
    const [selectedStaff, setSelectedStaff] = useState(null);
    const [schedules, setSchedules] = useState([]);
    
    const [loading, setLoading] = useState(true);
    const [savingSchedule, setSavingSchedule] = useState(false);
    const [showAddModal, setShowAddModal] = useState(false);
    const [formLoading, setFormLoading] = useState(false);
    const [message, setMessage] = useState({ text: '', type: '' });

    const [newStaff, setNewStaff] = useState({
        name: '',
        phone: '',
        services: []
    });

    // const [activeTab, setActiveTab] = useState('schedules'); // 'schedules' یا 'bookings'
    const [bookings, setBookings] = useState([]);
    const [loadingBookings, setLoadingBookings] = useState(false);





        // استیت‌های تب اصلی ادمین: 'staff' (مدیریت پرسنل) یا 'services' (مدیریت خدمات سالن)
    const [mainTab, setMainTab] = useState('staff'); 

    // استیت تب داخل پرسنل: 'schedules' (شیفت‌ها) | 'bookings' (نوبت‌ها) | 'services' (خدمات کارمند)
    const [staffTab, setStaffTab] = useState('schedules');

    // خدمات مربوط به کارمند انتخاب‌شده
    const [staffAssignedServices, setStaffAssignedServices] = useState([]);
    const [savingStaffServices, setSavingStaffServices] = useState(false);

    // فرم ثبت/ویرایش خدمت سالن
    const [editingService, setEditingService] = useState(null); // اگر null باشد یعنی در حال افزودن هستیم
    const [serviceForm, setServiceForm] = useState({
        name: '',
        price: '',
        duration_minutes: 30,
        description: ''
    });
    const [savingService, setSavingService] = useState(false);

    useEffect(() => {
    document.title = 'پنل مدیریت سالن';
    }, []);


    useEffect(() => {
        if (!slug) return;
        fetchInitialData();
    }, [slug]);

    const fetchInitialData = async () => {
        setLoading(true);
        try {
            // دریافت اطلاعات کاربر فعلی و سالن به‌صورت همزمان
            const [userRes, salonRes, staffRes, servicesRes] = await Promise.all([
                api.get('/user'),
                api.get(`/salons/${slug}`),
                api.get(`/salons/${slug}/staff-management`),
                api.get(`/salons/${slug}/services`)
            ]);

            const currentUser = userRes.data.user || userRes.data;
            const salonData = salonRes.data.data || salonRes.data;
            setSalon(salonData);

            // 1. بررسی مالکیت مستقیم سالن
            const isOwner = salonData.owner_id === currentUser.id;

            // 2. بررسی نقش کاربر از طریق لیست سالن‌های کاربر (از روت GET /user)
            const userSalonRelation = currentUser.salons?.find(s => s.slug === slug || s.id === salonData.id);
            const userRoleFromUserApi = userSalonRelation?.role;

            // 3. بررسی نقش کاربر از طریق آرایه کاربران سالن (در صورت لود شدن در api سالن)
            const isManagerInSalonUsers = salonData.users?.some(
                u => u.id === currentUser.id && ['owner', 'manager'].includes(u.pivot?.role)
            );

            // شرط نهایی دسترسی: مالک باشد، یا نقش owner/manager در پیوت داشته باشد
            const hasAccess = isOwner || 
                              ['owner', 'manager'].includes(userRoleFromUserApi) || 
                              isManagerInSalonUsers;

            if (!hasAccess) {
                alert('شما دسترسی لازم برای مدیریت این سالن را ندارید.');
                navigate(`/salons/${slug}/profile`);
                return;
            }

            const staffData = staffRes.data.data || staffRes.data || [];
            setStaffList(staffData);
            
            const serviceData = servicesRes.data.data || servicesRes.data || [];
            setServices(serviceData);

            if (staffData.length > 0) {
                setSelectedStaff(staffData[0]);
            }
        } catch (err) {
            console.error('Error loading admin data:', err);
            
            // اگر توکن منقضی شده یا لاگین نیست
            if (err.response?.status === 401) {
                alert('لطفاً ابتدا وارد حساب کاربری خود شوید.');
                navigate(`/salons/${slug}`); 
            } 
            // اگر کاربر لاگین است اما دسترسی به این سالن خاص ندارد
            else {
                alert('شما اجازه دسترسی به این بخش را ندارید.');
                navigate(`/salons/${slug}/profile`); // بازگشت به صفحه اصلی
            }
        } finally {
            setLoading(false);
        }
    };













    // دریافت خدمات تخصیص‌یافته به کارمند انتخاب‌شده
const fetchStaffAssignedServices = async (staffId) => {
    try {
        const res = await api.get(`/salons/${slug}/staff/${staffId}/services`);
        const list = res.data.data || [];
        // ذخیره آرایه‌ای از idهای خدمات فعال برای این کارمند
        setStaffAssignedServices(list.map(s => s.id));
    } catch (err) {
        console.error('Error fetching staff services:', err);
    }
};

// تغییر تیک یک خدمت برای کارمند
const handleToggleStaffService = (serviceId) => {
    setStaffAssignedServices(prev => 
        prev.includes(serviceId)
            ? prev.filter(id => id !== serviceId)
            : [...prev, serviceId]
    );
};

// ذخیره خدمات کارمند در سرور
const handleSaveStaffServices = async () => {
    if (!selectedStaff) return;
    setSavingStaffServices(true);
    try {
        await api.post(`/salons/${slug}/staff/${selectedStaff.id}/services`, {
            service_ids: staffAssignedServices
        });
        alert('خدمات کارمند با موفقیت به‌روزرسانی شد.');
    } catch (err) {
        alert('خطا در ذخیره خدمات کارمند: ' + (err.response?.data?.message || err.message));
    } finally {
        setSavingStaffServices(false);
    }
};

// دریافت مجدد کل خدمات سالن
const refreshSalonServices = async () => {
    try {
        const res = await api.get(`/salons/${slug}/services`);
        setServices(res.data.data || res.data || []);
    } catch (err) {
        console.error(err);
    }
};

// ثبت یا ویرایش خدمت سالن
const handleSaveSalonService = async (e) => {
    e.preventDefault();
    setSavingService(true);
    try {
        if (editingService) {
            await api.put(`/salons/${slug}/services/${editingService.id}`, serviceForm);
            alert('خدمت با موفقیت ویرایش شد.');
        } else {
            await api.post(`/salons/${slug}/services`, serviceForm);
            alert('خدمت جدید با موفقیت اضافه شد.');
        }

        setServiceForm({
            name: '',
            price: '',
            duration_minutes: 30,
            description: ''
        });
        setEditingService(null);
        await refreshSalonServices();
    } catch (err) {
        alert('خطا در ثبت خدمت: ' + (err.response?.data?.message || err.message));
    } finally {
        setSavingService(false);
    }
};

// تابع ویرایش خدمت
const handleEditSalonService = (service) => {
    setEditingService(service);
    setServiceForm({
        name: service.name || '',
        price: service.price || '',
        duration_minutes: service.duration_minutes || 30,
        description: service.description || ''
    });
    setMainTab('services');
};

// حذف خدمت سالن
const handleDeleteSalonService = async (serviceId) => {
    if (!window.confirm('آیا از حذف این خدمت اطمینان دارید؟')) return;
    try {
        await api.delete(`/salons/${slug}/services/${serviceId}`);
        await refreshSalonServices();
    } catch (err) {
        alert('خطا در حذف خدمت: ' + (err.response?.data?.message || err.message));
    }
};









    // // ۱. دریافت داده‌های اولیه سالن فقط با slug
    // useEffect(() => {
    //     if (!slug) return;
    //     fetchInitialData();
    // }, [slug]);

    // const fetchInitialData = async () => {
    //     setLoading(true);
    //     try {
    //         const [salonRes, staffRes, servicesRes] = await Promise.all([
    //             api.get(`/salons/${slug}`),
    //             api.get(`/salons/${slug}/staff-management`),
    //             api.get(`/salons/${slug}/services`)
    //         ]);

    //         const salonData = salonRes.data.data || salonRes.data;
    //         setSalon(salonData);

    //         const staffData = staffRes.data.data || staffRes.data || [];
    //         setStaffList(staffData);
            
    //         const serviceData = servicesRes.data.data || servicesRes.data || [];
    //         setServices(serviceData);

    //         if (staffData.length > 0) {
    //             setSelectedStaff(staffData[0]);
    //         }
    //     } catch (err) {
    //         console.error('Error loading admin data:', err);
    //         setMessage({ text: 'خطا در دریافت اطلاعات سالن', type: 'error' });
    //     } finally {
    //         setLoading(false);
    //     }
    // };

    // ۲. دریافت شیفت‌های آرایشگر انتخاب‌شده
useEffect(() => {
    if (!selectedStaff || !slug) return;
    fetchStaffSchedules(selectedStaff.id);
    fetchStaffBookings(selectedStaff.id);
    fetchStaffAssignedServices(selectedStaff.id);
}, [selectedStaff, slug]);

    const fetchStaffSchedules = async (staffId) => {
        try {
            const res = await api.get(`/salons/${slug}/staff/${staffId}/schedules`);
            const existingSchedules = res.data.data || [];

            const formatted = DAYS_OF_WEEK.map((day) => {
                const found = existingSchedules.find(s => Number(s.day_of_week) === day.id);
                return {
                    day_of_week: day.id,
                    day_name: day.name,
                    is_active: found ? Boolean(found.is_active) : day.id !== 6,
                    start_time: found?.start_time ? found.start_time.slice(0, 5) : '09:00',
                    end_time: found?.end_time ? found.end_time.slice(0, 5) : '21:00',
                    break_start: found?.break_start ? found.break_start.slice(0, 5) : '13:00',
                    break_end: found?.break_end ? found.break_end.slice(0, 5) : '14:00',
                };
            });

            setSchedules(formatted);
        } catch (err) {
            console.error('Error fetching schedules:', err);
        }
    };

    // تغییر مقدار در فرم شیفت
    const handleScheduleChange = (dayIndex, field, value) => {
        setSchedules(prev => {
            const next = [...prev];
            next[dayIndex] = { ...next[dayIndex], [field]: value };
            return next;
        });
    };

    // ذخیره شیفت‌ها با استفاده از slug
    const handleSaveSchedules = async () => {
        if (!selectedStaff) return;
        setSavingSchedule(true);
        setMessage({ text: '', type: '' });

        try {
            await api.post(`/salons/${slug}/staff/${selectedStaff.id}/schedules`, {
                schedules: schedules.map(s => ({
                    day_of_week: s.day_of_week,
                    start_time: s.start_time,
                    end_time: s.end_time,
                    break_start: s.break_start || null,
                    break_end: s.break_end || null,
                    is_active: s.is_active ? 1 : 0
                }))
            });

            setMessage({ text: 'برنامه کاری با موفقیت به‌روزرسانی شد.', type: 'success' });
            setTimeout(() => setMessage({ text: '', type: '' }), 4000);
        } catch (err) {
            console.error('Error saving schedule:', err);
            setMessage({ text: 'خطا در ذخیره برنامه کاری.', type: 'error' });
        } finally {
            setSavingSchedule(false);
        }
    };

    // ثبت آرایشگر جدید
    const handleCreateStaff = async (e) => {
        e.preventDefault();
        setFormLoading(true);

        try {
            const res = await api.post(`/salons/${slug}/staff-management`, newStaff);
            
            setMessage({ text: 'آرایشگر جدید با موفقیت اضافه شد.', type: 'success' });
            setShowAddModal(false);
            setNewStaff({ name: '', phone: '', services: [] });
            
            // به‌روزرسانی مجدد لیست پرسنل
            const staffRes = await api.get(`/salons/${slug}/staff-management`);
            const updatedList = staffRes.data.data || [];
            setStaffList(updatedList);

            if (res.data?.data) {
                setSelectedStaff(res.data.data);
            }
        } catch (err) {
            console.error('Error creating staff:', err);
            alert(err.response?.data?.message || 'خطا در ثبت پرسنل جدید');
        } finally {
            setFormLoading(false);
        }
    };

    const toggleServiceSelection = (serviceId) => {
        setNewStaff(prev => {
            const exists = prev.services.includes(serviceId);
            return {
                ...prev,
                services: exists 
                    ? prev.services.filter(id => id !== serviceId)
                    : [...prev.services, serviceId]
            };
        });
    };



    const fetchStaffBookings = async (staffId) => {
        setLoadingBookings(true);
        try {
            const res = await api.get(`/salons/${slug}/staff/${staffId}/bookings`);
            setBookings(res.data.data || []);
        } catch (err) {
            console.error('Error fetching bookings:', err);
        } finally {
            setLoadingBookings(false);
        }
    };

    useEffect(() => {
        if (!selectedStaff || !slug) return;
        fetchStaffSchedules(selectedStaff.id);
        fetchStaffBookings(selectedStaff.id);
    }, [selectedStaff, slug]);




    if (loading) {
        return (
            <div className="salon-container loading-state">
                <div className="loading-spinner"></div>
                <p>در حال بارگذاری پنل مدیریت...</p>
            </div>
        );
    }

    return (
        <div className="salon-container admin-theme">




























            {/* نوار بالا */}
            <div className="salon-header" style={{ backgroundImage: `url("${salon.cover_url}")`, marginBottom: '1.5rem', display: 'flex', justifyContent: 'space-around', alignItems: 'center' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                    <Link to={`/salons/${slug}/profile`} className="back-btn" title="بازگشت به صفحه سالن">
                        <ArrowRight size={20} />
                    </Link>
                    <div>
                        <h1 style={{ fontSize: '1.4rem', fontWeight: 800, margin: 0 }}>پنل مدیریت سالن</h1>
                        <p style={{ margin: 0, color: 'var(--text-muted)', fontSize: '0.85rem' }}>{salon?.name}</p>
                    </div>
                </div>
                <button 
                    className="book-btn-primary" 
                    onClick={() => setShowAddModal(true)} 
                    style={{ width: 'auto', padding: '0.6rem 1.2rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}
                >
                    <Plus size={18} />
                    <span>افزودن آرایشگر</span>
                </button>
            </div>

            {/* اعلان وضعیت */}
            {message.text && (
                <div className={`notification-banner ${message.type}`} style={{
                    padding: '0.75rem 1rem',
                    borderRadius: '12px',
                    marginBottom: '1.5rem',
                    backgroundColor: message.type === 'success' ? 'rgba(34, 197, 94, 0.15)' : 'rgba(239, 68, 68, 0.15)',
                    color: message.type === 'success' ? '#4ade80' : '#f87171',
                    border: `1px solid ${message.type === 'success' ? '#22c55e' : '#ef4444'}`,
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem'
                }}>
                    {message.type === 'success' ? <Check size={18} /> : <AlertCircle size={18} />}
                    <span>{message.text}</span>
                </div>
            )}











<div style={{ display: 'flex', gap: '1rem', marginBottom: '1.5rem' }}>
    <button
        type="button"
        onClick={() => setMainTab('staff')}
        style={{
            padding: '10px 20px',
            borderRadius: '10px',
            border: 'none',
            fontWeight: 'bold',
            cursor: 'pointer',
            background: mainTab === 'staff' ? '#ff7a00' : 'rgba(255,255,255,0.06)',
            color: mainTab === 'staff' ? '#000' : '#fff'
        }}
    >
        👥 مدیریت پرسنل و نوبت‌ها
    </button>
    <button
        type="button"
        onClick={() => setMainTab('services')}
        style={{
            padding: '10px 20px',
            borderRadius: '10px',
            border: 'none',
            fontWeight: 'bold',
            cursor: 'pointer',
            background: mainTab === 'services' ? '#ff7a00' : 'rgba(255,255,255,0.06)',
            color: mainTab === 'services' ? '#000' : '#fff'
        }}
    >
        ✂️ مدیریت خدمات سالن
    </button>
</div>




{mainTab === 'staff' && (
    /* گرید پنل مدیریت */
    <div className="admin-grid" style={{ display: 'grid', gridTemplateColumns: '280px 1fr', gap: '1.5rem' }}>
        {/* ستون راست: لیست پرسنل */}
        <div className="admin-sidebar" style={{ background: 'var(--card-bg, #1a1a24)', padding: '1.2rem', borderRadius: '16px', border: '1px solid rgba(255,255,255,0.05)' }}>
            <h3 style={{ fontSize: '1rem', marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <Users size={18} color="#ff7a00" />
                پرسنل سالن ({staffList.length})
            </h3>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.6rem' }}>
                {staffList.map((st) => (
                    <div
                        key={st.id}
                        onClick={() => setSelectedStaff(st)}
                        style={{
                            padding: '0.75rem 1rem',
                            borderRadius: '10px',
                            cursor: 'pointer',
                            border: selectedStaff?.id === st.id ? '1px solid #ff7a00' : '1px solid rgba(255,255,255,0.05)',
                            background: selectedStaff?.id === st.id ? 'rgba(255, 122, 0, 0.12)' : 'rgba(255,255,255,0.02)',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            transition: 'all 0.2s ease'
                        }}
                    >
                        <div>
                            <div style={{ fontWeight: 600, fontSize: '0.95rem', color: selectedStaff?.id === st.id ? '#ff7a00' : '#fff' }}>
                                {st.name}
                            </div>
                            <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)' }}>{st.phone}</div>
                        </div>
                        {st.role === 'manager' && (
                            <span style={{ fontSize: '0.7rem', padding: '0.2rem 0.5rem', background: 'rgba(59, 130, 246, 0.2)', color: '#60a5fa', borderRadius: '4px', border: '1px solid rgba(59, 130, 246, 0.3)' }}>
                                مدیر
                            </span>
                        )}
                    </div>
                ))}
            </div>
        </div>

        {/* ستون چپ: مدیریت شیفت‌ها، نوبت‌ها و خدمات کارمند */}
        <div className="admin-content" style={{ background: 'var(--card-bg, #1a1a24)', padding: '1.5rem', borderRadius: '16px', border: '1px solid rgba(255,255,255,0.05)' }}>
            {selectedStaff ? (
                <>
                    {/* هدر دکمه‌های تب کارمند */}
                    <div style={{ display: 'flex', gap: '0.8rem', marginBottom: '1.2rem', borderBottom: '1px solid rgba(255,255,255,0.08)', paddingBottom: '0.8rem' }}>
                        <button
                            type="button"
                            onClick={() => setStaffTab('schedules')}
                            style={{
                                background: staffTab === 'schedules' ? '#ff7a00' : 'rgba(255,255,255,0.05)',
                                color: staffTab === 'schedules' ? '#000' : '#fff',
                                border: 'none',
                                padding: '0.5rem 1rem',
                                borderRadius: '8px',
                                fontWeight: 700,
                                cursor: 'pointer'
                            }}
                        >
                            📅 تنظیم شیفت‌های هفتگی
                        </button>
                        <button
                            type="button"
                            onClick={() => setStaffTab('bookings')}
                            style={{
                                background: staffTab === 'bookings' ? '#ff7a00' : 'rgba(255,255,255,0.05)',
                                color: staffTab === 'bookings' ? '#000' : '#fff',
                                border: 'none',
                                padding: '0.5rem 1rem',
                                borderRadius: '8px',
                                fontWeight: 700,
                                cursor: 'pointer'
                            }}
                        >
                            📋 لیست نوبت‌های رزرو شده ({bookings.length})
                        </button>
                        <button
                            type="button"
                            onClick={() => setStaffTab('services')}
                            style={{
                                background: staffTab === 'services' ? '#ff7a00' : 'rgba(255,255,255,0.05)',
                                color: staffTab === 'services' ? '#000' : '#fff',
                                border: 'none',
                                padding: '0.5rem 1rem',
                                borderRadius: '8px',
                                fontWeight: 700,
                                cursor: 'pointer'
                            }}
                        >
                            ✂️ خدمات این کارمند ({staffAssignedServices.length})
                        </button>
                    </div>

                    {/* محتوای تب ۱: شیفت‌های هفتگی */}
                    {staffTab === 'schedules' && (
                        <>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem', borderBottom: '1px solid rgba(255,255,255,0.08)', paddingBottom: '1rem' }}>
                                <div>
                                    <h2 style={{ fontSize: '1.2rem', margin: 0 }}>
                                        برنامه کاری هفتگی: <span style={{ color: '#ff7a00' }}>{selectedStaff.name}</span>
                                    </h2>
                                    <p style={{ margin: '0.3rem 0 0 0', color: 'var(--text-muted)', fontSize: '0.85rem' }}>
                                        روزهای فعال، ساعات حضور و زمان استراحت را تعیین کنید.
                                    </p>
                                </div>
                                <button 
                                    onClick={handleSaveSchedules} 
                                    disabled={savingSchedule}
                                    className="book-btn-primary"
                                    style={{ width: 'auto', padding: '0.5rem 1.2rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}
                                >
                                    <Save size={16} />
                                    <span>{savingSchedule ? 'در حال ذخیره...' : 'ذخیره شیفت‌ها'}</span>
                                </button>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.8rem' }}>
                                {schedules.map((sch, idx) => (
                                    <div 
                                        key={sch.day_of_week}
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            padding: '0.85rem 1rem',
                                            background: sch.is_active ? 'rgba(255,255,255,0.03)' : 'rgba(239, 68, 68, 0.05)',
                                            borderRadius: '12px',
                                            border: sch.is_active ? '1px solid rgba(255,255,255,0.05)' : '1px solid rgba(239, 68, 68, 0.15)'
                                        }}
                                    >
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', minWidth: '110px' }}>
                                            <input 
                                                type="checkbox"
                                                id={`day-${sch.day_of_week}`}
                                                checked={sch.is_active}
                                                onChange={(e) => handleScheduleChange(idx, 'is_active', e.target.checked)}
                                                style={{ width: '18px', height: '18px', accentColor: '#ff7a00', cursor: 'pointer' }}
                                            />
                                            <label htmlFor={`day-${sch.day_of_week}`} style={{ fontWeight: 600, cursor: 'pointer', fontSize: '0.95rem' }}>
                                                {sch.day_name}
                                            </label>
                                        </div>

                                        {sch.is_active ? (
                                            <div style={{ display: 'flex', gap: '1.2rem', alignItems: 'center', flexWrap: 'wrap' }}>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '0.4rem' }}>
                                                    <span style={{ fontSize: '0.8rem', color: 'var(--text-muted)' }}>ساعت کاری:</span>
                                                    <input 
                                                        type="time" 
                                                        value={sch.start_time}
                                                        onChange={(e) => handleScheduleChange(idx, 'start_time', e.target.value)}
                                                        style={{ background: '#0d0d12', border: '1px solid rgba(255,255,255,0.1)', color: '#fff', borderRadius: '6px', padding: '0.25rem 0.4rem' }}
                                                    />
                                                    <span style={{ fontSize: '0.8rem', color: 'var(--text-muted)' }}>تا</span>
                                                    <input 
                                                        type="time" 
                                                        value={sch.end_time}
                                                        onChange={(e) => handleScheduleChange(idx, 'end_time', e.target.value)}
                                                        style={{ background: '#0d0d12', border: '1px solid rgba(255,255,255,0.1)', color: '#fff', borderRadius: '6px', padding: '0.25rem 0.4rem' }}
                                                    />
                                                </div>

                                                <div style={{ display: 'flex', alignItems: 'center', gap: '0.4rem' }}>
                                                    <span style={{ fontSize: '0.8rem', color: 'var(--text-muted)' }}>استراحت:</span>
                                                    <input 
                                                        type="time" 
                                                        value={sch.break_start || ''}
                                                        onChange={(e) => handleScheduleChange(idx, 'break_start', e.target.value)}
                                                        style={{ background: '#0d0d12', border: '1px solid rgba(255,255,255,0.1)', color: '#fff', borderRadius: '6px', padding: '0.25rem 0.4rem' }}
                                                    />
                                                    <span style={{ fontSize: '0.8rem', color: 'var(--text-muted)' }}>تا</span>
                                                    <input 
                                                        type="time" 
                                                        value={sch.break_end || ''}
                                                        onChange={(e) => handleScheduleChange(idx, 'break_end', e.target.value)}
                                                        style={{ background: '#0d0d12', border: '1px solid rgba(255,255,255,0.1)', color: '#fff', borderRadius: '6px', padding: '0.25rem 0.4rem' }}
                                                    />
                                                </div>
                                            </div>
                                        ) : (
                                            <span style={{ color: '#ef4444', fontSize: '0.85rem', fontWeight: 500 }}>تعطیل / مرخصی</span>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </>
                    )}

                    {/* محتوای تب ۲: لیست نوبت‌ها */}
                    {staffTab === 'bookings' && (
                        <div style={{ overflowX: 'auto' }}>
                            {loadingBookings ? (
                                <p style={{ textAlign: 'center', color: '#888', padding: '1rem' }}>در حال دریافت نوبت‌ها...</p>
                            ) : bookings.length === 0 ? (
                                <p style={{ textAlign: 'center', color: '#888', padding: '2rem' }}>هیچ نوبت رزرو شده‌ای برای این آرایشگر ثبت نشده است.</p>
                            ) : (
                                <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'right', fontSize: '0.88rem' }}>
                                    <thead>
                                        <tr style={{ background: 'rgba(255,255,255,0.04)', color: '#aaa', borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
                                            <th style={{ padding: '10px' }}>مشتری</th>
                                            <th style={{ padding: '10px' }}>شماره تماس</th>
                                            <th style={{ padding: '10px' }}>خدمت</th>
                                            <th style={{ padding: '10px' }}>تاریخ</th>
                                            <th style={{ padding: '10px' }}>ساعت</th>
                                            <th style={{ padding: '10px' }}>مبلغ</th>
                                            <th style={{ padding: '10px' }}>وضعیت</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {bookings.map((b) => (
                                            <tr key={b.id} style={{ borderBottom: '1px solid rgba(255,255,255,0.04)' }}>
                                                <td style={{ padding: '10px', fontWeight: 600 }}>{b.customer_name}</td>
                                                <td style={{ padding: '10px', direction: 'ltr', textAlign: 'right' }}>{b.customer_phone}</td>
                                                <td style={{ padding: '10px', color: '#ff7a00' }}>{b.service_name}</td>
                                                <td style={{ padding: '10px' }}>{b.date}</td>
                                                <td style={{ padding: '10px' }}>{b.time}</td>
                                                <td style={{ padding: '10px' }}>{Number(b.total_price).toLocaleString()} ت</td>
                                                <td style={{ padding: '10px' }}>
                                                    <span style={{
                                                        padding: '3px 8px',
                                                        borderRadius: '6px',
                                                        fontSize: '0.75rem',
                                                        background: b.status === 'confirmed' ? 'rgba(34,197,94,0.15)' : 'rgba(239,68,68,0.15)',
                                                        color: b.status === 'confirmed' ? '#4ade80' : '#f87171'
                                                    }}>
                                                        {b.status === 'confirmed' ? 'تأیید شده' : b.status}
                                                    </span>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            )}
                        </div>
                    )}

                    {/* محتوای تب ۳: تخصیص خدمات به پرسنل */}
                    {staffTab === 'services' && (
                        <div style={{ background: 'rgba(255,255,255,0.02)', padding: '1.5rem', borderRadius: '12px' }}>
                            <h3 style={{ marginBottom: '1rem', color: '#ff7a00' }}>انتخاب خدمات قابل ارائه توسط {selectedStaff.name || selectedStaff.user?.name}</h3>
                            
                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: '1rem', marginBottom: '1.5rem' }}>
                                {services.map(srv => {
                                    const isChecked = staffAssignedServices.includes(srv.id);
                                    return (
                                        <label
                                            key={srv.id}
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '0.75rem',
                                                padding: '12px',
                                                borderRadius: '8px',
                                                background: isChecked ? 'rgba(255,122,0,0.12)' : 'rgba(255,255,255,0.04)',
                                                border: isChecked ? '1px solid #ff7a00' : '1px solid rgba(255,255,255,0.08)',
                                                cursor: 'pointer'
                                            }}
                                        >
                                            <input
                                                type="checkbox"
                                                checked={isChecked}
                                                onChange={() => handleToggleStaffService(srv.id)}
                                                style={{ accentColor: '#ff7a00', width: '18px', height: '18px' }}
                                            />
                                            <div>
                                                <div style={{ fontWeight: 600 }}>{srv.name}</div>
                                                <div style={{ fontSize: '0.8rem', color: '#aaa' }}>{Number(srv.price).toLocaleString()} تومان • {srv.duration_minutes} دقیقه</div>
                                            </div>
                                        </label>
                                    );
                                })}
                            </div>

                            <button
                                onClick={handleSaveStaffServices}
                                disabled={savingStaffServices}
                                style={{
                                    background: '#ff7a00',
                                    color: '#000',
                                    fontWeight: 700,
                                    border: 'none',
                                    padding: '10px 24px',
                                    borderRadius: '8px',
                                    cursor: 'pointer'
                                }}
                            >
                                {savingStaffServices ? 'در حال ذخیره...' : 'ذخیره تغییرات خدمات'}
                            </button>
                        </div>
                    )}
                </>
            ) : (
                <p style={{ textAlign: 'center', color: 'var(--text-muted)', padding: '2rem' }}>لطفاً یک آرایشگر را از لیست سمت راست انتخاب کنید.</p>
            )}
        </div>
    </div>
)}

{mainTab === 'services' && (
    <div className='admin-grid' style={{ display: 'grid', gridTemplateColumns: '280px 1fr', gap: '1.5rem' }}>
        {/* فرم ثبت یا ویرایش خدمت */}
        <div className="admin-sidebar" style={{ background: 'var(--card-bg, #1a1a24)', padding: '1.2rem', borderRadius: '16px', border: '1px solid rgba(255,255,255,0.05)' }}>
            <h3 style={{ marginBottom: '1rem', color: '#ff7a00' }}>
                {editingService ? 'ویرایش خدمت' : 'افزودن خدمت جدید سالن'}
            </h3>
            <form onSubmit={handleSaveSalonService}>
                <div style={{ marginBottom: '1rem' }}>
                    <label style={{ display: 'block', marginBottom: '0.4rem', fontSize: '0.85rem' }}>نام خدمت:</label>
                    <input
                        type="text"
                        required
                        value={serviceForm.name}
                        onChange={e => setServiceForm({ ...serviceForm, name: e.target.value })}
                        style={{ width: '100%', padding: '8px 12px', borderRadius: '6px', background: '#111', border: '1px solid #333', color: '#fff' }}
                    />
                </div>
                <div style={{ marginBottom: '1rem' }}>
                    <label style={{ display: 'block', marginBottom: '0.4rem', fontSize: '0.85rem' }}>قیمت (تومان):</label>
                    <input
                        type="number"
                        required
                        value={serviceForm.price}
                        onChange={e => setServiceForm({ ...serviceForm, price: e.target.value })}
                        style={{ width: '100%', padding: '8px 12px', borderRadius: '6px', background: '#111', border: '1px solid #333', color: '#fff' }}
                    />
                </div>
                <div style={{ marginBottom: '1rem' }}>
                    <label style={{ display: 'block', marginBottom: '0.4rem', fontSize: '0.85rem' }}>مدت زمان (دقیقه):</label>
                    <input
                        type="number"
                        required
                        value={serviceForm.duration_minutes}
                        onChange={e => setServiceForm({ ...serviceForm, duration_minutes: e.target.value })}
                        style={{ width: '100%', padding: '8px 12px', borderRadius: '6px', background: '#111', border: '1px solid #333', color: '#fff' }}
                    />
                </div>
                <div style={{ marginBottom: '1.2rem' }}>
                    <label style={{ display: 'block', marginBottom: '0.4rem', fontSize: '0.85rem' }}>توضیحات (اختیاری):</label>
                    <textarea
                        rows="3"
                        value={serviceForm.description}
                        onChange={e => setServiceForm({ ...serviceForm, description: e.target.value })}
                        style={{ width: '100%', padding: '8px 12px', borderRadius: '6px', background: '#111', border: '1px solid #333', color: '#fff' }}
                    />
                </div>
                <div style={{ display: 'flex', gap: '0.5rem' }}>
                    <button
                        type="submit"
                        disabled={savingService}
                        style={{ flex: 1, background: '#ff7a00', color: '#000', fontWeight: 'bold', padding: '10px', borderRadius: '6px', border: 'none', cursor: 'pointer' }}
                    >
                        {savingService ? 'در حال ثبت...' : (editingService ? 'بروزرسانی خدمت' : 'ثبت خدمت')}
                    </button>
                    {editingService && (
                        <button
                            type="button"
                            onClick={() => {
                                setEditingService(null);
                                setServiceForm({ name: '', price: '', duration_minutes: 30, description: '' });
                            }}
                            style={{ background: '#333', color: '#fff', padding: '10px', borderRadius: '6px', border: 'none', cursor: 'pointer' }}
                        >
                            انصراف
                        </button>
                    )}
                </div>
            </form>
        </div>

        {/* لیست و جدول خدمات سالن */}
        <div className="admin-content" style={{ background: 'var(--card-bg, #1a1a24)', padding: '1.5rem', borderRadius: '16px', border: '1px solid rgba(255,255,255,0.05)' }}>
            <h3 style={{ marginBottom: '1rem' }}>لیست خدمات سالن ({services.length})</h3>
            <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'right' }}>
                <thead>
                    <tr style={{ background: 'rgba(255,255,255,0.04)', color: '#aaa', borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
                        <th style={{ padding: '10px' }}>عنوان خدمت</th>
                        <th style={{ padding: '10px' }}>قیمت</th>
                        <th style={{ padding: '10px' }}>مدت زمان</th>
                        <th style={{ padding: '10px' }}>عملیات</th>
                    </tr>
                </thead>
                <tbody>
                    {services.map((s) => (
                        <tr key={s.id} style={{ borderBottom: '1px solid rgba(255,255,255,0.04)' }}>
                            <td style={{ padding: '10px', fontWeight: 600 }}>{s.name}</td>
                            <td style={{ padding: '10px' }}>{Number(s.price).toLocaleString()} تومان</td>
                            <td style={{ padding: '10px' }}>{s.duration_minutes} دقیقه</td>
                            <td style={{ padding: '10px' }}>
                                <button
                                    onClick={() => handleEditSalonService(s)}
                                    style={{ background: 'rgba(255,122,0,0.15)', color: '#ff7a00', border: 'none', padding: '5px 10px', borderRadius: '6px', cursor: 'pointer', marginLeft: '6px' }}
                                >
                                    ✏️ ویرایش
                                </button>
                                <button
                                    onClick={() => handleDeleteSalonService(s.id)}
                                    style={{ background: 'rgba(239,68,68,0.15)', color: '#f87171', border: 'none', padding: '5px 10px', borderRadius: '6px', cursor: 'pointer' }}
                                >
                                    🗑️ حذف
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    </div>
)}





            {/* مدال افزودن پرسنل جدید */}
            {showAddModal && (
                <div className="modal-overlay" style={{
                    position: 'fixed',
                    top: 0, left: 0, right: 0, bottom: 0,
                    backgroundColor: 'rgba(0,0,0,0.75)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 1000,
                    backdropFilter: 'blur(4px)'
                }}>
                    <div style={{
                        background: '#16161f',
                        padding: '1.5rem',
                        borderRadius: '16px',
                        width: '90%',
                        maxWidth: '450px',
                        border: '1px solid rgba(255,255,255,0.1)'
                    }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.2rem' }}>
                            <h3 style={{ margin: 0, fontSize: '1.1rem' }}>افزودن آرایشگر جدید</h3>
                            <button onClick={() => setShowAddModal(false)} style={{ background: 'none', border: 'none', color: '#fff', cursor: 'pointer' }}>
                                <X size={20} />
                            </button>
                        </div>

                        <form onSubmit={handleCreateStaff} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                            <div>
                                <label style={{ fontSize: '0.85rem', color: 'var(--text-muted)', display: 'block', marginBottom: '0.3rem' }}>نام آرایشگر</label>
                                <input 
                                    type="text" 
                                    required 
                                    placeholder="مثلاً: علی رضایی"
                                    value={newStaff.name}
                                    onChange={(e) => setNewStaff({ ...newStaff, name: e.target.value })}
                                    style={{ width: '100%', padding: '0.6rem', borderRadius: '8px', background: '#0a0a0f', border: '1px solid rgba(255,255,255,0.1)', color: '#fff' }}
                                />
                            </div>

                            <div>
                                <label style={{ fontSize: '0.85rem', color: 'var(--text-muted)', display: 'block', marginBottom: '0.3rem' }}>شماره تماس (جهت ورود به پنل)</label>
                                <input 
                                    type="text" 
                                    required 
                                    placeholder="09123456789"
                                    value={newStaff.phone}
                                    onChange={(e) => setNewStaff({ ...newStaff, phone: e.target.value })}
                                    style={{ width: '100%', padding: '0.6rem', borderRadius: '8px', background: '#0a0a0f', border: '1px solid rgba(255,255,255,0.1)', color: '#fff' }}
                                />
                            </div>

                            <div>
                                <label style={{ fontSize: '0.85rem', color: 'var(--text-muted)', display: 'block', marginBottom: '0.5rem' }}>انتخاب سرویس‌های قابل ارائه</label>
                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem', maxHeight: '140px', overflowY: 'auto' }}>
                                    {services.map(srv => {
                                        const isSelected = newStaff.services.includes(srv.id);
                                        return (
                                            <div 
                                                key={srv.id}
                                                onClick={() => toggleServiceSelection(srv.id)}
                                                style={{
                                                    padding: '0.4rem 0.8rem',
                                                    borderRadius: '8px',
                                                    fontSize: '0.8rem',
                                                    cursor: 'pointer',
                                                    border: isSelected ? '1px solid #ff7a00' : '1px solid rgba(255,255,255,0.1)',
                                                    background: isSelected ? 'rgba(255,122,0,0.15)' : 'rgba(255,255,255,0.03)',
                                                    color: isSelected ? '#ff7a00' : '#ccc',
                                                    userSelect: 'none'
                                                }}
                                            >
                                                {srv.name}
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>

                            <button 
                                type="submit" 
                                disabled={formLoading}
                                className="book-btn-primary" 
                                style={{ marginTop: '0.5rem' }}
                            >
                                {formLoading ? 'در حال ثبت...' : 'ثبت پرسنل'}
                            </button>
                        </form>
                    </div>
                </div>
            )}


        </div>
    );
}
